import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { DateTimeStandard } from "@curves/ui-base";
import { Overview } from "@curves/ui-shared";
import { isValidDate, parseDate } from "@util/moment";

const headerRow = [
	{
		cellKey: "reportDate",
		headerLabel: "回報日期",
		align: "center",
		formatCell: value => (value ? parseDate(value, DateTimeStandard.DisplayDateBySlash) : "—"),
	},
	{ cellKey: "employeeName", headerLabel: "回報人" },
	{ cellKey: "reportReason", headerLabel: "回報原因" },
	{
		cellKey: "processDate",
		headerLabel: "處理日期",
		align: "center",
		formatCell: value => (isValidDate(value) ? parseDate(value, DateTimeStandard.DisplayDateBySlash) : <span className="text-error">處理中</span>),
	},
	{ cellKey: "processTypeName", headerLabel: "處理類型" },
	{ cellKey: "processorName", headerLabel: "處理人" },
	{ cellKey: "processReason", headerLabel: "處理原因" },
];

/**
 * 瑕疵紀錄列表
 * 含分頁、總筆數、表格
 * @param {Object} props
 * @param {Object} props.defectOverviewData - Overview 資料 { list, pagination }
 * @param {Function} props.updateDefectPage - 換頁回調
 * @param {string} [props.className]
 */
const StockDefectRecords = ({ defectOverviewData, updateDefectPage, className = "" }) => {
	const contextValue = useMemo(() => ({ overviewData: defectOverviewData, updateOverviewPage: updateDefectPage }), [defectOverviewData, updateDefectPage]);

	return (
		<Overview contextValue={contextValue} idKey="clubDefectiveReportID" className={className}>
			<Overview.TotalCount className="text-right mb-2" showCurrentCount />
			<Overview.Table headerRow={headerRow} tableClassName="theme-gray" className="mb-3" />
			<Overview.Pagination />
		</Overview>
	);
};

StockDefectRecords.propTypes = {
	defectOverviewData: PropTypes.shape({
		list: PropTypes.array,
		pagination: PropTypes.shape({
			pageIndex: PropTypes.number,
			totalPage: PropTypes.number,
			totalCount: PropTypes.number,
		}),
	}),
	updateDefectPage: PropTypes.func,
	className: PropTypes.string,
};

export default StockDefectRecords;
export { headerRow as stockDefectRecordsHeaderRow };
